import $ from 'jquery';

import { Skin } from 'lib/vendor/terrific/Application';

import LegoContainer from '../Tc.Module.LegoContainer';
// tslint:disable-next-line: no-duplicate-imports
import type { LegoContainerConfig } from '../Tc.Module.LegoContainer';

interface DetailPageSkin extends LegoContainer {
	updateUI(data : LegoContainerConfig[]) : void;
}

// tslint:disable-next-line: variable-name
export const DetailPage : Skin<LegoContainer, DetailPageSkin> = function DetailPage(parent) {
	this.cacheUi = function() {
		parent.cacheUi.call(this);

		this.ui.detailContainers = this.$ctx.find('.legoDetailContainer');
		this.ui.detailContainers.toggleClass('hidden', !this.isEditMode);
		this.$ctx.addClass('initialized');
	};

	this.handleDataSuccess = function() {
		if(this.isEditMode) {
			return;
		}

		const initConf = this.deepLinkConf;

		if(initConf && initConf.config.length) {
			this.setInitialOptions(initConf.options);
			this.initComplete = true;
			this.updateUI(initConf.config);
			this.updateSummaryUi(initConf.config);
			this.broadcastConfigurationChanged(this.currentSelection, this.calculateTotalPrice(initConf.config));
		}
	};

	this.updateUI = function(data) {
		const mod = this;
		this.ui.detailContainers.toggleClass('hidden', true);

		$.each(data, function(_i, service) {
			mod.ui.detailContainers.filter(`[data-id="${service.slideId}"]`).toggleClass('hidden', false);
		});
	};
};



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/ecommerce/lego/skins/DetailPage.ts